// extracted by mini-css-extract-plugin
export default {"avatar":"RTAvatar-avatar-2yMiB","letter":"RTAvatar-letter-3kMca"};